(function(){
'use strict';

function getVariantId(link){
  try{return new URL(link.href,window.location.origin).searchParams.get('variant');}
  catch(e){return null;}
}

async function nativeFinderAdd(btn){
  const card=btn.closest('.afres,.pf-result,.affitcard')||btn.parentElement;
  const link=card?card.querySelector('.hlfc-view'):null;
  const status=card?card.querySelector('.hlfc-status'):null;
  const variantId=link?getVariantId(link):null;
  if(!variantId)return;

  btn.disabled=true;
  btn.textContent='ADDING…';
  if(status)status.textContent='';

  try{
    const cartDrawer=document.querySelector('cart-drawer');
    let sections='cart-icon-bubble';
    if(cartDrawer){
      const wrapper=cartDrawer.closest('.shopify-section');
      if(wrapper)sections+=','+wrapper.id.replace('shopify-section-','');
    }

    const formData=new FormData();
    formData.append('id',variantId);
    formData.append('quantity','1');
    formData.append('sections_url',window.location.pathname);
    formData.append('sections',sections);

    const response=await fetch((window.theme&&theme.routes&&theme.routes.cartAdd)?theme.routes.cartAdd:'/cart/add',{
      method:'POST',
      headers:{
        'Accept':'application/javascript',
        'X-Requested-With':'XMLHttpRequest'
      },
      body:formData
    });
    const data=await response.json();
    if(!response.ok||data.status)throw new Error(data.description||data.message||'Unable to add item');

    const bubble=document.getElementById('cart-icon-bubble');
    if(bubble&&data.sections&&data.sections['cart-icon-bubble']){
      bubble.innerHTML=data.sections['cart-icon-bubble'];
    }

    if(cartDrawer&&data.sections&&typeof cartDrawer.renderContents==='function'){
      await cartDrawer.renderContents(data,true);
    }else{
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
    }

    btn.textContent='ADDED TO BASKET ✓';
    if(status)status.innerHTML='Added successfully. <a class="hlfc-cartlink" href="/cart">View basket</a>';

    document.dispatchEvent(new CustomEvent('on:cart:add',{
      bubbles:true,
      detail:{variantId:Number(variantId)}
    }));

    setTimeout(function(){
      btn.disabled=false;
      btn.textContent='ADD TO BASKET →';
    },1200);
  }catch(error){
    btn.disabled=false;
    btn.textContent='ADD TO BASKET →';
    if(status)status.textContent='Sorry, that could not be added. Please use “View full product”.';
    console.log(error);
  }
}

document.addEventListener('click',function(evt){
  const btn=evt.target.closest&&evt.target.closest('.hlfc-add');
  if(!btn||btn.disabled)return;
  evt.preventDefault();
  evt.stopImmediatePropagation();
  nativeFinderAdd(btn);
},true);
})();
